import script from "./FixLightsFuckOff.vue?vue&type=script&setup=true&lang=js"
export * from "./FixLightsFuckOff.vue?vue&type=script&setup=true&lang=js"

import "./FixLightsFuckOff.vue?vue&type=style&index=0&id=a26acb14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a26acb14"]])

export default __exports__